import { cn } from "@/lib/utils";

import { lightTone } from "./draftText";
import type { Draft } from "./types";

const dotClass = {
  success: "bg-success",
  destructive: "bg-destructive",
  warning: "bg-warning",
} as const;

export const TrafficLightDot = ({
  light,
  className,
}: {
  light: Draft["ampel"];
  className?: string;
}) =>
  light ? (
    <span
      aria-label={light}
      className={cn(
        "inline-block size-2.5 shrink-0 rounded-full",
        dotClass[lightTone(light)],
        className,
      )}
    />
  ) : null;
